<template>
    <b-modal id="deleteCustomerModal" centered modal-class="modal-garden-help modal-confirm-message">
      <div class="d-block mb-2">
        <input id="customer_id" name="customer_id" type="hidden" v-model="customer_id" />
        <input id="client" name="client" type="hidden" v-model="client_name" />
        <!-- <img src="@/assets/images/garden-help/close-circle.png" class="close-img" /> -->
        <!-- <h4 class="title-confirm-modal ">Delete Customer</h4> -->
        <h4 class="title-confirm-modal ">Are you sure you want to delete this customer?</h4>
        <!-- <p class="message-confirm-modal text-center my-3 ">
          Are you sure you want to delete this customer?
        </p> -->
      </div>
  
      <template class="justify-content-center mt-5" #modal-footer>
        <b-row class="justify-content-center w-100 m-0">
          <b-col xl="4" lg="5" md="6" class="text-center">
            <b-button type="button" variant="garden-help-info-outline" class="btn-bumblebee btn-garden-help mb-1 w-100"
              @click="closeModalCancel">
              Cancel
            </b-button>
          </b-col>
          <b-col xl="4" lg="5" md="6" class="text-center">
            <b-button type="button" variant="garden-help-danger" class="btn-bumblebee btn-garden-help mb-1 w-100"
              v-if="!is_loading" @click="clickConfirmDelete">
              Yes
            </b-button>
            <b-button type="button" disabled variant="garden-help-danger" class="btn-bumblebee btn-garden-help  mb-1 w-100"
              v-else>
              <b-spinner small label="Small Spinner" variant="light"></b-spinner>
              Loading
            </b-button>
          </b-col>
  
        </b-row>
      </template>
    </b-modal>
  </template>
  <script>
  import $ from "jquery";
  import axios from "axios";
  
  export default {
    name: "DeleteCustomer",
    props: ["client_name", "customer_id"],
    data() {
      return {
        is_loading: false,
      };
    },
  
    mounted() { },
  
    methods: {
      clickConfirmDelete() {
        console.log("in confirm cancel customer ", this.client_name, this.customer_id);

  
        this.is_loading = true;
       
        axios
          .delete(
            "/admin/users/" + this.customer_id,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                client: this.client_name,
                Authorization:
                  "Bearer " +
                  JSON.parse(window.localStorage.getItem("user")).access_token,
              },
            }
          )
          .then((response) => {
            console.log(response);
            this.is_loading = false;
            this.$fire({
              text: "Customer is deleted successfully.",
              type: "success",
              customClass: {
                container: "swal-alert-garden-help",
                confirmButton:
                  "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                cancelButton:
                  "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
              },
  
            }).then((r) => {
              this.$bvModal.hide("deleteCustomerModal");
              this.$parent.getCustomersList()
            //   this.$router
            //     .go({ name: "GardenHelpCustomerCurrentList" })
            //     .catch(() => { });
            });
          })
          .catch((error) => {
            console.log(error);
            this.is_loading = false;
  
            this.$fire({
              // title: "Title",
              text: error.response.data.error,
              type: "error",
              customClass: {
                container: "swal-alert-garden-help",
                confirmButton:
                  "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                cancelButton:
                  "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
              },
              // timer: 5000,
            }).then((r) => {
            });
  
          });
      },
      closeModalCancel() {
        this.$bvModal.hide("deleteCustomerModal");
      },
    },
  };
  </script>
      


// WEBPACK FOOTER //
// src/projects/garden_help/customer/modal_actions/DeleteCustomer.vue